import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutPropertiesLoose from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js";
var _excluded = ["to", "linkAs"],
  _excluded2 = ["activeClassName", "as", "className", "href", "linkAs", "noLinkStyle"];
import * as React from 'react';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import NextLink from 'next/link';
import MuiLink from '@mui/material/Link';
import { useUserLanguage } from '../i18n';
import { useDocsConfig } from '../DocsProvider';

/**
 * File to keep in sync with:
 *
 * - /packages/mui-docs/src/Link/Link.tsx
 * - /examples/material-ui-nextjs-pages-router/src/Link.js
 * - /examples/material-ui-nextjs-pages-router-ts/src/Link.tsx
 * - /examples/material-ui-nextjs-ts-v4-v5-migration/src/Link.tsx
 */
import { jsx as _jsx } from "react/jsx-runtime";
export var NextLinkComposed = /*#__PURE__*/React.forwardRef(function NextLinkComposed(props, ref) {
  var to = props.to,
    linkAs = props.linkAs,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(NextLink, _extends({
    href: to,
    as: linkAs,
    "data-no-markdown-link": "true",
    ref: ref
  }, other));
});
if (false) NextLinkComposed.displayName = "NextLinkComposed";
// A styled version of the Next.js Link component:
// https://nextjs.org/docs/pages/api-reference/components/link
export var Link = /*#__PURE__*/React.forwardRef(function Link(props, ref) {
  var _props$activeClassNam = props.activeClassName,
    activeClassName = _props$activeClassNam === void 0 ? 'active' : _props$activeClassNam,
    as = props.as,
    classNameProps = props.className,
    href = props.href,
    linkAsProp = props.linkAs,
    noLinkStyle = props.noLinkStyle,
    other = _objectWithoutPropertiesLoose(props, _excluded2);
  var router = useRouter();
  var pathname = typeof href === 'string' ? href : href == null ? void 0 : href.pathname;
  var routerPathname = router.pathname.replace('/[docsTab]', '');
  var className = clsx(classNameProps, _defineProperty({}, activeClassName, routerPathname === pathname && activeClassName));
  var userLanguage = useUserLanguage();
  var _useDocsConfig = useDocsConfig(),
    LANGUAGES_IGNORE_PAGES = _useDocsConfig.LANGUAGES_IGNORE_PAGES;
  var linkAs = linkAsProp || as || href;
  if (userLanguage !== 'en' && pathname && pathname.startsWith('/') && !LANGUAGES_IGNORE_PAGES(pathname) && !pathname.startsWith("/".concat(userLanguage, "/"))) {
    linkAs = "/".concat(userLanguage).concat(linkAs);
  }
  var nextjsProps = {
    to: href,
    linkAs: linkAs
  };
  if (noLinkStyle) {
    return /*#__PURE__*/_jsx(NextLinkComposed, _extends({
      className: className,
      ref: ref
    }, nextjsProps, other));
  }
  return /*#__PURE__*/_jsx(MuiLink, _extends({
    component: NextLinkComposed,
    className: className,
    ref: ref
  }, nextjsProps, other));
});
if (false) Link.displayName = "Link";